// extracted by mini-css-extract-plugin
export default {"root":"PlayButton_root__r3Bis","image":"PlayButton_image__YAKCW","button":"PlayButton_button__HbTAk","icon":"PlayButton_icon__NoMkd"};